<template>
  <div class="login-container">
    <!-- 登录页 -->
    <section class="section">
      <div class="content">
        <div style="padding-bottom:40px;">
          <h2>登录帮助</h2>
        </div>

        <div class="loginhelp-text-tip" v-show="true">
          <span>
            1、忘记密码?
            <br />可联系自己所在企业的超级管理员重置密码。
            <br />
            <br />
          </span>
          <span>
            2、忘记租户编号(租户id)?
            <br />注册开通时已将企业专属租户id通过短信方式发送给企业的超级管理员，可直接询问自己所在企业的超级管理员。或者拨打智能通讯融合平台服务热线021-39518970，联系云平台客服协助解决，服务时间：每周一至周五 9:00---18:00（国定假日除外）
            <br />
            <br />
          </span>
          <span>
            3、企业超级管理员忘记密码?
            <br />可通过注册时手机号验证的方式重置超级管理员密码
            <br />
            <a href="#" @click="goToForgetPassword">点击此处进入手机验证重置页面</a>
            <br />
            <br />
          </span>
          <span>
            <a href="#" @click="goToLogin">返回登录页</a>
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },

  methods: {
    // 立即登录
    goToLogin() {
      this.$router.push({ path: '/login' })
    },
    // 前往忘记密码页面
    goToForgetPassword() {
      this.$router.push({ path: '/forgetPassword' })
    }
  }
}
</script>

<style scoped>
@import "../../../assets/scss/login/login.css";
</style>
